import {FC, Card} from 'external/react'
import {convertDateToText} from 'utilities/text'
import SubscriptionStatus from 'components/SubscriptionStatus'
import { Package } from 'types/context/package'

type PlanInfoProps = {
   className?: string
   packageItem: Package | null 
}

const PlanInfo: FC<PlanInfoProps> = props => {
    const {packageItem, className} = props
   return (
    <Card className={className} style={{ borderRadius: '10px' }}>
        <Card.Header className='header-card-color'></Card.Header>
        <Card.Body>
            {packageItem?.id && (<>
                <div className='d-flex justify-content-between mb-2'>
                    <p className='text-capitalize' style={{ fontWeight: '500', margin: '0' }}>
                        Plan {packageItem?.offerName}
                    </p>
                    {packageItem?.subscriptionStatus !== null && <SubscriptionStatus status={packageItem?.subscriptionStatus} subscription={packageItem?.subscription} />}
                </div>
                <p style={{ margin: '0' }}>
                    <span>
                        Miembro desde <b>{convertDateToText(packageItem?.purchaseDate)}</b>
                    </span>
                </p>
            </>)}
        </Card.Body>
    </Card>
   )
}

export {PlanInfo as default}